import { Tree } from "fluid-framework";
import { useEffect } from "react";

import { useLayoutStore } from "../../store/layout.store.js";
import { getUser } from "../fluid/fluid.service.js";
import { useFluid } from "../fluid/hooks/use-fluid.js";

export const useInactivityDetection = ({
  enabled,
  presenceReady,
}: {
  enabled: boolean;
  presenceReady: boolean;
}) => {
  const {
    __ctx_init: joinReady,
    connectionState,
    containerId,
    fluidUserId,
    sharedTree,
  } = useFluid();
  const { setModalVariant } = useLayoutStore();

  useEffect(() => {
    if (!(enabled && joinReady)) {
      return;
    }

    const handleKickedCheck = () => {
      const user = getUser({ sharedTree, userId: fluidUserId });
      if (
        user?.isOnline === false &&
        !useLayoutStore.getState().isLeavingOffice
      ) {
        if (
          useLayoutStore.getState().modalVariant !== "kicked_for_inactivity"
        ) {
          const duplicateCount =
            sharedTree.root.users.filter(
              (candidate) => candidate.id === fluidUserId
            ).length - 1;
          console.info("[presence] opening office removal dialog", {
            connectionState,
            containerId,
            duplicateCount,
            fluidUserId,
            joinReady,
            presenceReady,
          });
        }
        setModalVariant("kicked_for_inactivity");
      }
    };

    // Set up Fluid tree listener for real-time detection
    const unsubscribeFluid = Tree.on(
      sharedTree.root.users,
      "treeChanged",
      handleKickedCheck
    );

    // Perform initial check immediately after subscribing.
    // This catches cases where the user was kicked before the listener was set up,
    // e.g., during app initialization or effect re-runs.
    handleKickedCheck();

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        // Check if we're still in office after coming back
        handleKickedCheck();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      unsubscribeFluid();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [
    enabled,
    joinReady,
    fluidUserId,
    sharedTree,
    setModalVariant,
    connectionState,
    containerId,
    presenceReady,
  ]);
};
